import React from 'react'
import Tabs from './Tabs'

const ResetStateWithKey = () => {
  return (
    <div>
        <h2>Reset state with key prop</h2>
        <Tabs />
    </div>
  )
}

export default ResetStateWithKey